<template>
  <div>
    <div id="banner">
      <div class="slider-pro sp-horizontal" id="example1" style="width: 100%; max-width: 5200px">
        <div class="sp-slides">
         
        <!--
          <div class="sp-slide">
            <a href="javascript:void(1)"><img
                class="sp-image"
                src="~@/assets/15002842221.jpg"
                alt=""
                title="" /></a>
          </div>
          -->
          <div class="sp-slide">
            <a href="javascript:void(1)"><img
                class="sp-image"
                src="~@/assets/15011452161.png"
                alt=""
                title=""/></a>
          </div>
        </div>
      </div>
    </div>
    <div id="wrap_c">
      <div class="breadCrumb">
        <a href="/" tabindex="101" class="breadCrumb_no" title="首頁">首頁</a>
        <router-link :to="{name:'公司簡介'}"><span>關於白金</span></router-link>
        <router-link :to="{name:'公司簡介'}"><span>公司簡介</span></router-link>
      </div>

      <h2 class="titleA">公司簡介</h2>
      <div id="page_left">
        <div id="menu_out">
          <div id="menu_c">
            <ul class="m_top"></ul>
            <li>
              <router-link :to="{name:'公司簡介'}" class="menu_on0">關於白金</router-link>
              <span
                style="cursor: hand"
                class="arrow_class_close"
                onclick="allshow_show_menu2(this,'2279','http://','0','','2280')">
                <img
                  src="~@/assets/folder_close.png"
                  id="img_son_menu_2279"
                  class="class_sonimg_0"/>
              </span>
            </li>
            <div id="son_menu_2279" class="class_sondiv_0" style="display: ">
              <ol>
                <router-link :to="{name:'公司簡介'}" class="menu_on2">公司簡介</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'經營理念'}" class="menu_on0">經營理念</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'核心競爭力'}" class="menu_on0">核心競爭力</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'企業沿革'}" class="menu_on0">企業沿革</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'企業社會責任'}" class="menu_on0">企業社會責任</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'產業新聞'}" class="menu_on0">產業新聞</router-link>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <div id="page_right_no">
        <!--###右側欄區塊###-->
      </div>

      <div id="page_main_2">
        <!--###內頁中間內容區塊###-->
        <div class="cC">
          <form
            method="POST"
            action="portal_c2_cnt.php?owner_num=c2_38424&amp;button_num=c2&amp;folder_id=2280&amp;search_type=1"
          >
            <div class="searchbar">
              <ul>
                <li>
                  尋找：

                  <select tabindex="62" name="search_field">
                    <option value="all_field">全部</option>
                    <option value="text_field_0">標題</option>
                  </select>
                  <input
                    tabindex="63"
                    name="search_word"
                    type="text"
                    class="input"
                    value=""
                  />
                  <input
                    tabindex="64"
                    name="search_b1"
                    type="submit"
                    class="btn"
                    value="查詢"
                  />
                  <!--<input name="Submit3" type="button" class="btn2" value="進階查詢" onclick="location.href='http://www.ptotinc.com/member/ptotinc/portal_c2_cnt.php?owner_num=c2_38424&button_num=c2&folder_id=2280&search_type=2';"/>-->
                </li>
              </ul>
            </div>
          </form>

          <div class="cate_info">
            <span style="font-size: 15px"
              ><strong><span style="font-size: 18px">公司簡介</span></strong
              ><br />
              <br />
              光學玻璃材料專業製造廠<br />
              &nbsp;<br />
              光學玻璃材質都以特殊成分的配方、熔融時間、冷卻方式與時間等等的差異來改變（或決定）其光學性能。光學玻璃的透明度及其內部的均一性必須要十分良好；又由於「像差
              補正」的需要，有關它對光的折射及色散之特性，必需精確掌握。因此，光學玻璃所使用原材料，不僅經過精密的選別，並且需要以現代科學化的
              管理與技術來製造。<br />
              &nbsp;<br />
              本公司經營團隊擁有完整的基礎光學材料研發及製程開發技術，並有10年以上量產實務經驗，經多年埋首研究，已成功開發出應用於光電產業的各類光電介面材料。本公司專注於研究、開發及生產光電介面材料，目前主要產品為搭配影像感測器之吸收式紅外線濾光鏡片，係應用於數位影像之關鍵元件，其他產品亦將陸續推出。</span
            >
          </div>

          <ul id="c_list"></ul>

          <br /><br />
          <p style="text-align: center"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'intro',
  data () {
    return {
      isAboutPage: true,
      publicPath: 'kfkasldkfjaklsdf'
    }
  },
  created: function () {
    console.log('created')
  },
  mounted: function () {
    console.log('moundted')
    this.init()
    this.$emit('setCurrentMenu', 'about'); // about/ product/ recruit/ contactus
  },
  methods: {
    init: function () {
      $('#rwd_nav').pageslide({
          modal: true
      });
      $('.sp-selected .sp-font span').addClass('animated fadeInLeft');
      $('.sp-selected .sp-font2').addClass('animated fadeInRight');
      $('#example1').sliderPro({
          keyboardOnlyOnFocus: true,
          set_swipe: '1',
          width: '5120',
          height: '1280',
          autoplay: true,
          waitForLayers: true,
          autoScaleLayers: false,
          fade: true,
          autoplayDelay: 5000,
          arrows: false,
          buttons: false,
          breakpoints: {
            1024: {
              forceSize: '',
              width: '1024',
              height: '256'
            }
          }
      });
      sliderPro_add_title('default', '%%%%%%%%%@@@%%%%%%%%%@@@', '%%%%%%%%%@@@%%%%%%%%%@@@');
      // initVideo();
    }
  }
}
</script>
<style src='@/assets/css/15347449502.css'>
</style>


// WEBPACK FOOTER //
// src/components/about/Intro.vue